import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {PreviewBsiRoutingModule} from "./preview-bsi-routing.module";
import {GlobalModule} from "../global/global.module";
import {PreviewBsiComponent} from "./preview-bsi.component";



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    PreviewBsiRoutingModule,
    GlobalModule
  ],
  declarations: [
    PreviewBsiComponent
  ]
})
export class PreviewBsiModule { }
